(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["juice-stockists"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (e) {
    var pill = e.target.closest('.jx-stk__pill');
    if (!pill) return;
    var root = pill.closest('.jx-stk');
    if (!root) return;
    var region = pill.getAttribute('data-region') || '';
    root.querySelectorAll('.jx-stk__pill').forEach(function (p) {
      p.setAttribute('aria-pressed', p === pill ? 'true' : 'false');
    });
    root.querySelectorAll('.jx-stk__cell[data-region]').forEach(function (cell) {
      var match = !region || cell.getAttribute('data-region') === region;
      cell.hidden = !match;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
